module.exports = __webpack_public_path__ + "img/AssinarPlano.30324af4.png";